import HttpUtil from '../util/HttpUtil';
import { showGlobalLoaderType, hideGlobalLoaderType, showSnackBarType } from './NavMenu';

const startAddUserType = 'START_ADD_TG_USER';
export const addUserType = 'ADD_TG_USER';
export const errorType = 'ERROR_ADD_TG_USER_TYPE';
export const editUserType = 'EDIT_TG_USER';
export const deleteUserType = 'DELETE_TG_USER';
const stopSavingType = "STOP_TG_USER_SAVING";

const initialState = {
    isSaving: false,
    rights: null,
    user: null,
    clients: [],
    error: null
};

export const actionCreators = {
    startLoadUser: () => ({ type: showGlobalLoaderType }),
    stopLoadUser: () => ({ type: hideGlobalLoaderType }),
    showSnackBar: (message) => ({ type: showSnackBarType, message }),
    addUser: (fields, callback) => async (dispatch, getState) => {
        dispatch({
            type: startAddUserType
        });

        dispatch({
            type: showGlobalLoaderType
        });

        HttpUtil.fetchEdit("api/TelegramUsers/Create", JSON.stringify(fields), "POST", false,
            data => {
                if (data.error) {
                    dispatch({
                        type: showSnackBarType,
                        message:  data.error
                    });

                    dispatch({
                        type: errorType
                    });

                    callback("/telegram");

                    dispatch({
                        type: hideGlobalLoaderType
                    });

                    return;
                }
                dispatch({
                    type: addUserType,
                    error: data.error,
                    fields: {
                        ...fields,
                        id: data.id
                    }
                });

                dispatch({
                    type: showSnackBarType,
                    message: "Новый пользователь Telegram успешно добавлен!"
                });

                callback("/telegram");

                dispatch({
                    type: hideGlobalLoaderType
                });
            }
        );
    },
    editUser: (fields, callback) => async (dispatch, getState) => {
        dispatch({
            type: startAddUserType
        });
        dispatch({
            type: showGlobalLoaderType
        });
        HttpUtil.fetchEdit('api/TelegramUsers/' + fields.id, JSON.stringify(fields), "PUT", false,
            data => {
                if (data.reason) {
                    dispatch({
                        type: showSnackBarType,
                        message: "Ошибка сервера: " + data.reason
                    });

                    dispatch({
                        type: hideGlobalLoaderType
                    });

                    return;
                }

                dispatch({
                    type: editUserType,
                    fields: {
                        ...fields,
                        status: fields.status === 1 ? "Заблокирован" : "Активен"
                    }
                });

                dispatch({
                    type: hideGlobalLoaderType
                });

                let message = "Пользователь Telegram успешно отредактирован!" 

                dispatch({
                    type: showSnackBarType,
                    message
                });

                callback("/telegram");
            }
        )
    },
    deleteUser: (id, callback) => async (dispatch, getState) => {
        dispatch({
            type: startAddUserType
        });
        dispatch({
            type: showGlobalLoaderType
        });

        HttpUtil.fetchEdit("api/TelegramUsers/" + id, {}, "DELETE", false,
            data => {
                dispatch({
                    type: hideGlobalLoaderType
                });

                if (data.error) {
                    alert(data.error);
                    dispatch({
                        type: stopSavingType
                    });
                    return;
                }

                dispatch({
                    type: deleteUserType,
                    id
                });

                dispatch({
                    type: showSnackBarType,
                    message: "Пользователь Telegram успешно удален!"
                });

                callback("/telegram");
            }
        )
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === startAddUserType) {
        return {
            ...state,
            isSaving: true
        }
    }

    if (action.type === addUserType) {
        return {
            ...state,
            isSaving: false
        }
    }

    if (action.type === errorType) {
        return {
            ...state,
            isSaving: false,
            error: action.error
        }
    }

    if (action.type === deleteUserType) {
        return {
            ...state,
            isSaving: false,
            error: null
        }
    }

    if (action.type === stopSavingType) {
        return {
            ...state,
            isSaving: false
        }
    }

    if (action.type === editUserType) {
        return {
            ...state,
            isSaving: false
        }
    }

    return state;
};
